// Sorted by Shopify market importance and usage
export const SUPPORTED_LANGUAGES = [
  // Tier 1: Primary markets - highest e-commerce usage
  {
    code: "en",
    name: "English",
    flag: "🇺🇸",
    nativeName: "English",
  },
  {
    code: "de",
    name: "German",
    flag: "🇩🇪",
    nativeName: "Deutsch",
  },
  {
    code: "fr",
    name: "French",
    flag: "🇫🇷",
    nativeName: "Français",
  },
  {
    code: "es",
    name: "Spanish",
    flag: "🇪🇸",
    nativeName: "Español",
  },
  {
    code: "it",
    name: "Italian",
    flag: "🇮🇹",
    nativeName: "Italiano",
  },

  // Tier 2: Major markets - significant e-commerce presence
  {
    code: "nl",
    name: "Dutch",
    flag: "🇳🇱",
    nativeName: "Nederlands",
  },
  {
    code: "pt-br",
    name: "Portuguese (Brazil)",
    flag: "🇧🇷",
    nativeName: "Português (Brasil)",
  },
  {
    code: "ja",
    name: "Japanese",
    flag: "🇯🇵",
    nativeName: "日本語",
  },
  {
    code: "zh-cn",
    name: "Chinese (Simplified)",
    flag: "🇨🇳",
    nativeName: "简体中文",
  },
  {
    code: "ko",
    name: "Korean",
    flag: "🇰🇷",
    nativeName: "한국어",
  },

  // Tier 3: European markets - good e-commerce adoption
  {
    code: "sv",
    name: "Swedish",
    flag: "🇸🇪",
    nativeName: "Svenska",
  },
  {
    code: "da",
    name: "Danish",
    flag: "🇩🇰",
    nativeName: "Dansk",
  },
  {
    code: "nb",
    name: "Norwegian (Bokmål)",
    flag: "🇳🇴",
    nativeName: "Norsk Bokmål",
  },
  {
    code: "fi",
    name: "Finnish",
    flag: "🇫🇮",
    nativeName: "Suomi",
  },
  {
    code: "pl",
    name: "Polish",
    flag: "🇵🇱",
    nativeName: "Polski",
  },

  // Tier 4: Growing markets
  {
    code: "pt",
    name: "Portuguese (Portugal)",
    flag: "🇵🇹",
    nativeName: "Português",
  },
  {
    code: "cs",
    name: "Czech",
    flag: "🇨🇿",
    nativeName: "Čeština",
  },
  {
    code: "tr",
    name: "Turkish",
    flag: "🇹🇷",
    nativeName: "Türkçe",
  },
  {
    code: "zh-tw",
    name: "Chinese (Traditional)",
    flag: "🇹🇼",
    nativeName: "繁體中文",
  },
  {
    code: "th",
    name: "Thai",
    flag: "🇹🇭",
    nativeName: "ไทย",
  },
];

export const getLanguageByCode = (code) => {
  return (
    SUPPORTED_LANGUAGES.find((lang) => lang.code === code) ||
    SUPPORTED_LANGUAGES[0]
  );
};

export const validateTranslationData = (data, languageCode) => {
  const errors = [];

  if (!data.title?.trim()) {
    errors.push(`Title is required for ${languageCode.toUpperCase()}`);
  }

  if (!data.content?.trim()) {
    errors.push(`Content is required for ${languageCode.toUpperCase()}`);
  }

  return errors;
};

export const getDefaultLanguage = () => "en";

export const isValidLanguageCode = (code) => {
  return SUPPORTED_LANGUAGES.some((lang) => lang.code === code);
};
